import {useTheme} from "@emotion/react";
import {useLocation, useNavigate} from "@remix-run/react";
import {useEffect, useState} from "react";
import bg404 from "../../assets/images/404bg.png";
import CTA from "../../elements/CTA";
import {H2} from "../../elements/semanticWrappers";
import {Text} from "../../elements/text";
import Footer from "../Footer";
import Header from "../Header";
import SectionWrapper from "../SectionWrapper";
import {LayoutWrapper} from "./style.js";

export const Page404 = ({data}) => {
  const {breakpoints} = useTheme();
  const {isMobile} = breakpoints;
  const menu = data;
  const language = data?.language;
  const basename = data?.basename;
  const translation = data?.translation;
  const footerData = data?.footer?.footer;
  const secondLevelFooterLinks = data?.secondFooterData;
  const footerLinks = data?.footerData;
  const headerText1 = translation?.["404-title-1"];
  const headerText2 = translation?.["404-title-2"];
  const subtitleText1 = translation?.["404-desc-1"];
  const subtitleText2 = translation?.["404-desc-2"];
  const buttonText = translation?.button404;

  const [showMenu, setShowMenu] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const redirectToHome = queryParams.get("r");

  useEffect(() => {
    if (redirectToHome) {
      navigate("/");
    }
  }, [redirectToHome, navigate]);

  if (redirectToHome) return null;

  return (
    <LayoutWrapper>
      <Header
        data={menu}
        basename={basename}
        setShowMenu={setShowMenu}
        showMenu={showMenu}
      />
      <SectionWrapper bgImage={bg404}>
        <div
          style={{
            gridColumn: isMobile ? "1/-1" : "3/15",
            paddingInline: isMobile ? 20 : 0,
          }}
        >
          <H2
            styles={{textAlign: "center", width: "100%", marginTop: isMobile ? 118 : 210}}
          >
            {headerText1 || "Oups !"}
          </H2>
          <H2 styles={{textAlign: "center", width: "100%"}}>
            {headerText2 || "La page que vous cherchez semble introuvable."}
          </H2>

          <Text
            type={"textLarge"}
            styles={{
              textAlign: "center",
              width: "100%",
              marginTop: 16,
              fontSize: "1.125rem",
              lineHeight: isMobile ? "24px" : "26px",
            }}
          >
            {subtitleText1 ||
              "Vous étiez sur le point d'arriver à votre destination mais la page que vous\n" +
                "recherchez n'est pas disponible."}
          </Text>
          <Text
            type={"textLarge"}
            styles={{
              textAlign: "center",
              width: "100%",
              fontSize: "1.125rem",
              lineHeight: isMobile ? "24px" : "26px",
            }}
          >
            {subtitleText2 ||
              " Retournez à notre page d'accueil et nous vous\n" +
                "aiderons à retrouver le bon chemin."}
          </Text>
          <div style={{display: "flex", justifyContent: "center"}}>
            <CTA
              to={"/"}
              buttonStyles={{margin: isMobile ? "35px auto 180px" : "30px auto 230px"}}
              size="medium"
              type={"primary"}
              buttonColor={"#27509B"}
            >
              {buttonText || "Page d'accueil"}
            </CTA>
          </div>
        </div>
      </SectionWrapper>
      <Footer
        language={language}
        footerLinks={footerLinks}
        secondLevelFooterLinks={secondLevelFooterLinks}
        footerData={footerData}
        isNewsletter={false}
      />
    </LayoutWrapper>
  );
};
